import Box from "@mui/material/Box";
import { blue, orange } from "@mui/material/colors";

const getColorTheme = (theme_str) => {
    if (theme_str === "company") {
        return ({
            weak : orange[50],
            semiWeak: orange[100],
            normal: orange[200],
            semiStrong: orange[300],
            strong: orange[400]
        })
    } else if (theme_str === "customer") {
        return ({ 
            weak : blue[50],
            semiWeak: blue[100],
            normal: blue[200],
            semiStrong: blue[300],
            strong: blue[400]
        })
    }
}

function CommonPartHeader(props) {
    return (
        <Box
            marginTop={2} marginBottom={1} padding={1}
            borderBottom={"3px " + getColorTheme(props.theme).strong + " solid"}
        >
          {props.children}
        </Box>
    )
}

export function CompanyPartHeader(props) {
    return (
        <CommonPartHeader theme="company">
            {props.children}
        </CommonPartHeader>
    )
}

export function CustomerPartHeader(props) {
    return (
        <CommonPartHeader theme="customer">
            {props.children}
        </CommonPartHeader>
    )
}